import React, { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";

// Plotly is loaded on demand (same chunk as the other 3D plots).
const SamplePickPlotInner = React.lazy(() => import("./SamplePickPlotInner"));

/** See SamplePickPlotInner for the props. */
export default function SamplePickPlot(props) {
    const height = props.height ?? 480;
    return (
        <Suspense
            fallback={
                <Box sx={{ height, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <CircularProgress size={28} thickness={4} aria-label="Loading the 3D plot" />
                </Box>
            }
        >
            <SamplePickPlotInner {...props} />
        </Suspense>
    );
}
